import { useState, useEffect } from "react";
import { useSettingsSection } from "@/lib/useSettingsSection";
import { PageTitle, Card, Field, inputCls, SaveButton } from "@/components/admin/ui";
import { ImageField } from "@/components/admin/MediaPicker";
import { Plus, Trash2 } from "lucide-react";

export default function AdminHomepage() {
  const { settings, saving, save } = useSettingsSection();
  const [hero, setHero] = useState({});
  const [about, setAbout] = useState({});
  const [approach, setApproach] = useState([]);
  const [cta, setCta] = useState({});

  useEffect(() => {
    if (settings) {
      setHero(settings.hero || {});
      setAbout(settings.about || {});
      setApproach(settings.approach || []);
      setCta(settings.cta || {});
    }
  }, [settings]);

  if (!settings) return <div className="text-slate-400">Loading…</div>;

  return (
    <div data-testid="admin-homepage">
      <PageTitle title="Homepage" subtitle="Edit hero, about, professional approach and CTA sections" />

      <div className="space-y-6">
        <Card title="Hero Section">
          <Field label="Heading"><input className={inputCls} value={hero.heading || ""} onChange={(e) => setHero({ ...hero, heading: e.target.value })} data-testid="hero-heading-input" /></Field>
          <Field label="Subheading"><input className={inputCls} value={hero.subheading || ""} onChange={(e) => setHero({ ...hero, subheading: e.target.value })} /></Field>
          <Field label="Main Headline"><input className={inputCls} value={hero.headline || ""} onChange={(e) => setHero({ ...hero, headline: e.target.value })} /></Field>
          <Field label="Supporting Copy"><textarea rows={3} className={inputCls} value={hero.supporting_copy || ""} onChange={(e) => setHero({ ...hero, supporting_copy: e.target.value })} /></Field>
          <Field label="Hero Portrait"><ImageField value={hero.portrait_url} onChange={(v) => setHero({ ...hero, portrait_url: v })} testid="hero-portrait-field" /></Field>
          <SaveButton onClick={() => save({ hero })} saving={saving} testid="save-hero" />
        </Card>

        <Card title="About Section">
          <Field label="Title"><input className={inputCls} value={about.title || ""} onChange={(e) => setAbout({ ...about, title: e.target.value })} /></Field>
          <Field label="About Text"><textarea rows={5} className={inputCls} value={about.text || ""} onChange={(e) => setAbout({ ...about, text: e.target.value })} data-testid="about-text-input" /></Field>
          <Field label="About Image"><ImageField value={about.image_url} onChange={(v) => setAbout({ ...about, image_url: v })} /></Field>
          <SaveButton onClick={() => save({ about })} saving={saving} testid="save-about" />
        </Card>

        <Card title="Professional Approach">
          {approach.map((a, i) => (
            <div key={i} className="flex gap-3 mb-3 items-start">
              <div className="flex-1 grid sm:grid-cols-2 gap-3">
                <input className={inputCls} placeholder="Title" value={a.title} onChange={(e) => { const n = [...approach]; n[i] = { ...a, title: e.target.value }; setApproach(n); }} />
                <input className={inputCls} placeholder="Description" value={a.desc} onChange={(e) => { const n = [...approach]; n[i] = { ...a, desc: e.target.value }; setApproach(n); }} />
              </div>
              <button onClick={() => setApproach(approach.filter((_, x) => x !== i))} className="text-red-500 p-2.5"><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={() => setApproach([...approach, { title: "", desc: "" }])} className="text-brass text-sm inline-flex items-center gap-1 mb-4"><Plus size={15} /> Add Principle</button>
          <div><SaveButton onClick={() => save({ approach })} saving={saving} testid="save-approach" /></div>
        </Card>

        <Card title="CTA Section">
          <Field label="Heading"><input className={inputCls} value={cta.heading || ""} onChange={(e) => setCta({ ...cta, heading: e.target.value })} /></Field>
          <Field label="Text"><input className={inputCls} value={cta.text || ""} onChange={(e) => setCta({ ...cta, text: e.target.value })} /></Field>
          <Field label="CTA Image (optional)"><ImageField value={cta.image_url} onChange={(v) => setCta({ ...cta, image_url: v })} /></Field>
          <SaveButton onClick={() => save({ cta })} saving={saving} testid="save-cta" />
        </Card>
      </div>
    </div>
  );
}
